import Loader from "components/common/loader";
import { HeaderCard } from "components/layout/surveyHeader/HeaderCard";

import { Anchor, ArrowLeft, CalendarBlank, Hash, User } from "phosphor-react";

import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capitalizeName, formatAddress } from "utils/common";
import "../survey/survey.scss";
import * as Yup from "yup";
import Input from "components/common/input";
import SelectComponent from "components/common/select";
import DateInput from "components/common/date-picker";
import { ErrorMessage, Formik } from "formik";
import { useLocation } from "react-router-dom";
import { getOrganizations } from "containers/community/api";
import { updateEncounter } from "containers/community/api";
import { COMMUNITY_OUTREACH_PATH } from "constants/routePaths";
import {
  EncounterFormSchema,
  EncounterFormInitialValues,
  EncounterLabels,
} from "constants/community";
import { initialMetaForTable, DEBOUNCE_DELAY } from "constants/common";
import { debounce } from "lodash";
import AddReferralsList from "components/referrals/AddReferralsList";
import { createReferral } from "containers/referrals/api";
import AddFormWithoutMember from "components/referrals/AddFromWithoutMember";
const useDebouncedFetchOrganizations = () => {
  const debouncedFetch = useRef(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getOrganizations({
          search: inputValue,
        });

        let formattedOptions =
          response?.community_engagements?.map((el) => ({
            value: el.id,
            label: el.name,
          })) || [];
        callback(formattedOptions);
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
        callback([]);
      }
    }, DEBOUNCE_DELAY)
  ).current;

  return debouncedFetch;
};

const StartEncounter = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const keyContacts = location.state.keyContacts || [];
  const organization = location.state.organization || {};
  const organizationInfo = location.state.organizationInfo || {};
  const [isreferralAddModalVisible, setreferralIsModalVisible] = useState(
    false
  );
  const [addNewMemberModal, setAddNewMemberModal] = useState(false);
  const [thankyouNote, setThankyouNote] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const debouncedFetchOrganizationData = useDebouncedFetchOrganizations();

  useEffect(() => {
    (async () => {
      const result = await getOrganizations({
        ...initialMetaForTable,
        page: 1,
      });
      if (result?.community_engagements) {
        setOrganizationList(result.community_engagements);
      }
    })();
  }, [debouncedFetchOrganizationData]);

  const handleAddNewMember = async (values) => {
    const result = await createReferral(values);
    if (result) {
      handleOpenThankyou();
    }
  };
  const handleOpenAddReferralModal = () => {
    setAddNewMemberModal(true);
  };
  const handleCloseAddModal = () => {
    setreferralIsModalVisible(false);
  };
  const handleOpenThankyou = () => {
    setThankyouNote(true);
  };

  const [loading, setLoading] = useState(false);
  const encounterID = params.id;
  const handleEncounterSubmit = async (encounter) => {
    const {
      encounterType,
      encounterDate,
      durationStart,
      durationEnd,
      resultOfOutreach,
      careManager,
      followUpDate,
      encounterDescription,
    } = encounter;
    const encounterPayload = {
      encounter: {
        id: encounterID,
        answers: {
          encounterType,
          encounterDate,
          durationStart,
          durationEnd,
          resultOfOutreach,
          careManager: keyContacts.find((contact) => contact.id == careManager),
          followUpDate,
          encounterDescription,
        },
        status: "complete",
      },
    };

    try {
      const result = await updateEncounter(encounterID, encounterPayload);
      if (encounter?.resultOfOutreach === "sentReferral") {
        setreferralIsModalVisible(true);
      } else {
        handleOpenThankyou();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const organizationContacts =
    organizationInfo?.organization_contacts?.map((contact) => ({
      value: contact.id,
      label: contact.name,
    })) || [];

  return (
    <>
      <div className="row ms-4">
        <div className="col">
          {loading ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : (
            <>
              <div className="row">
                {!thankyouNote && (
                  <h1 className="space w-100 text-center text-wrap mb-5">
                    {capitalizeName(params.user.replaceAll("-", " "))}
                  </h1>
                )}
              </div>
              <div className="card-container">
                {thankyouNote ? (
                  <div className=" d-flex w-100 justify-content-center  align-items-start gap-5 ">
                    <div
                      className=" w-50   bg-white text-center "
                      style={{ padding: "150px" }}
                    >
                      <p className="heading-h6">{`${params?.user} Has Been Submitted!`}</p>
                      <button
                        onClick={() => {
                          navigate(`${COMMUNITY_OUTREACH_PATH}`);
                        }}
                        className="primary-btn mt-5 "
                      >
                        Go Back to Community Engagement
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className=" d-flex w-100 justify-content-center  align-items-start gap-5 ">
                    {!isreferralAddModalVisible && !addNewMemberModal && (
                      <Formik
                        initialValues={EncounterFormInitialValues}
                        validationSchema={EncounterFormSchema}
                        onSubmit={(values) => {
                          handleEncounterSubmit(values);
                        }}
                      >
                        {({
                          handleChange,
                          values,
                          handleSubmit,
                          setFieldValue,
                          errors,
                        }) => {
                          return (
                            <div className="w-50 p-5  bg-white">
                              <form
                                className="form-main"
                                onSubmit={handleSubmit}
                              >
                                <h4 className=" mb-4">Encounter Questions</h4>
                                <div className="input-flex row">
                                  <div className="col-sm-6">
                                    <DateInput
                                      handleChange={(date) => {
                                        setFieldValue("encounterDate", date);
                                      }}
                                      value={values.encounterDate}
                                      label={EncounterLabels["encounterDate"]}
                                      name="encounterDate"
                                      placeholderText="Encounter Date "
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="encounterDate"
                                        />
                                      }
                                    />
                                  </div>

                                  <div className="col-sm-6">
                                    <Input
                                      handleChange={handleChange}
                                      placeholder="Select start time"
                                      type="time"
                                      label={EncounterLabels["durationStart"]}
                                      value={values.durationStart}
                                      name="durationStart"
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="durationStart"
                                        />
                                      }
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <Input
                                      handleChange={handleChange}
                                      placeholder="Select end time"
                                      type="time"
                                      label={EncounterLabels["durationEnd"]}
                                      value={values.durationEnd}
                                      name="durationEnd"
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="durationEnd"
                                        />
                                      }
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <SelectComponent
                                      label={EncounterLabels["careManager"]}
                                      options={organizationContacts}
                                      dataCallback={(inputValue) =>
                                        new Promise((resolve) => {
                                          const filteredContacts = organizationContacts.filter(
                                            (contact) =>
                                              contact.label
                                                .toLowerCase()
                                                .includes(
                                                  inputValue.toLowerCase()
                                                )
                                          );
                                          resolve(filteredContacts);
                                        })
                                      }
                                      selectedValue={values.careManager}
                                      placeholder="Select Contact"
                                      handleChange={(obj) => {
                                        setFieldValue("careManager", obj.value);
                                      }}
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="careManager"
                                        />
                                      }
                                    />
                                  </div>

                                  <div className="col-sm-6">
                                    <SelectComponent
                                      label={EncounterLabels["encounterType"]}
                                      options={[
                                        { value: "phone", label: "Phone" },
                                        { value: "text", label: "Text" },
                                        { value: "email", label: "Email" },
                                        { value: "mail", label: "Mail" },
                                        {
                                          value: "inPerson",
                                          label: "In Person",
                                        },
                                      ]}
                                      selectedValue={values.encounterType}
                                      placeholder="Select Type of Encounter"
                                      handleChange={(obj) => {
                                        setFieldValue(
                                          "encounterType",
                                          obj.value
                                        );
                                      }}
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="encounterType"
                                        />
                                      }
                                    />
                                  </div>

                                  <div className="col-sm-6">
                                    <SelectComponent
                                      label={
                                        EncounterLabels["resultOfOutreach"]
                                      }
                                      options={[
                                        {
                                          value: "sentReferral",
                                          label: "Sent Referral",
                                        },
                                        {
                                          value: "expressedInterest",
                                          label: "Expressed Interest",
                                        },
                                        {
                                          value: "pendingFollowUp",
                                          label: "Pending Follow Up",
                                        },
                                        {
                                          value: "disengage",
                                          label: "Disengage",
                                        },
                                      ]}
                                      selectedValue={values.resultOfOutreach}
                                      placeholder="Select result"
                                      handleChange={(obj) => {
                                        setFieldValue(
                                          "resultOfOutreach",
                                          obj.value
                                        );
                                      }}
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="resultOfOutreach"
                                        />
                                      }
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <DateInput
                                      handleChange={(date) => {
                                        setFieldValue("followUpDate", date);
                                      }}
                                      value={values.followUpDate}
                                      label={EncounterLabels["followUpDate"]}
                                      name="followUpDate"
                                      placeholderText="Follow up date "
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="followUpDate"
                                        />
                                      }
                                    />
                                  </div>
                                  <div className="col-sm-6">
                                    <Input
                                      handleChange={handleChange}
                                      placeholder="Type encounter description"
                                      type="text"
                                      rows={3}
                                      label={
                                        EncounterLabels["encounterDescription"]
                                      }
                                      value={values.encounterDescription}
                                      name="encounterDescription"
                                      className="mb-1"
                                      error={
                                        <ErrorMessage
                                          className="error-message"
                                          component="p"
                                          name="encounterDescription"
                                        />
                                      }
                                    />
                                  </div>
                                  <div className="col-sm-6  d-flex justify-content-center m-auto">
                                    <input
                                      className="primary-btn w-100 mt-4"
                                      type="submit"
                                      name="submit"
                                      value={"Submit Encounter"}
                                    />
                                  </div>
                                </div>
                              </form>
                            </div>
                          );
                        }}
                      </Formik>
                    )}

                    {isreferralAddModalVisible && (
                      <div className=" w-50 p-5  bg-white">
                        <AddReferralsList
                          handleOpenNewReferralForm={handleOpenAddReferralModal}
                          handleCloseAddModal={handleCloseAddModal}
                          handleOpenThankyouNote={handleOpenThankyou}
                        />
                      </div>
                    )}

                    {addNewMemberModal && (
                      <div className=" w-50 p-5  bg-white">
                        <AddFormWithoutMember
                          handleSubmitForm={handleAddNewMember}
                        />
                      </div>
                    )}
                    <div className="d-flex flex-column gap-3">
                      <div className=" w-25 p-5  border border-black  border-opacity-10 border-2 w-auto ps-4">
                        <h5 className="">Basic Info</h5>
                        <div className="mt-1 d-flex flex-column justify-content-between survey-space">
                          <HeaderCard
                            title="Name"
                            subTitle={organizationInfo.name || "N/A"}
                            // icon={<Hash />}
                          />
                          <HeaderCard
                            title="Type"
                            subTitle={
                              organizationInfo.organization_type || "N/A"
                            }
                            // icon={<User />}
                          />
                          <HeaderCard
                            title="Parent Company"
                            subTitle={organizationInfo.owner || "N/A"}
                            // icon={<CalendarBlank />}
                          />
                          <HeaderCard
                            title="Website"
                            subTitle={organizationInfo.website || "N/A"}
                            // icon={<Anchor />}
                          />
                          <HeaderCard
                            title="County"
                            subTitle={capitalizeName(
                              organizationInfo?.address?.county || "N/A"
                            )}
                            // icon={<Anchor />}
                          />
                          <HeaderCard
                            title="Address"
                            subTitle={
                              formatAddress(organizationInfo.address) || "N/A"
                            }
                            // icon={<Hash />}
                          />
                        </div>
                      </div>
                      <div className=" w-25 p-5  border border-black  border-opacity-10 border-2 w-auto ps-4 ">
                        <h5 className="">Contact Info</h5>
                        <div className="mt-1 d-flex flex-column justify-content-between survey-space">
                          <HeaderCard
                            title="Email"
                            subTitle={organizationInfo.email || "N/A"}
                            // icon={<Hash />}
                          />
                          <HeaderCard
                            title="Phone"
                            subTitle={organizationInfo.phone || "N/A"}
                            // icon={<Hash />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default StartEncounter;
